module.exports = __webpack_public_path__ + "static/media/EVAN_KUBES.78034d0b.png";